module.exports = __webpack_public_path__ + "img/load_on.61cb7113.svg";